<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("about.brand.breadcrumb")}}</div>
    <div class="container">
      <div class="des">
        <div class="title">{{$t("about.brand.title2")}}</div>
        <img src="~assets/about/idea.jpg"/>
        <div class="text" v-html='$t("about.brand.text2")'></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Idea',
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
    .des
      box-sizing border-box
      padding 0 23px
      margin-top 30px
      width 100%
      .title
        cn()
        font-size 20px
        font-weight bold
      .text
        text-indent 30px
</style>



// WEBPACK FOOTER //
// src/pages/about/components/Idea.vue